import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import TourDto from '@/features/dashboard/tourConfig/types/TourDto.ts';

const useGetTour = (tourId: string) => {
  return useQuery(getTourQueryOptions(tourId));
};

export const getTourQueryOptions = (
  tourId: string,
): UseQueryOptions<TourDto> => ({
  queryKey: toursApiQueryKeys.byId(tourId),
  queryFn: () => toursApi.getTour(tourId),
  enabled: tourId !== undefined,
});

export default useGetTour;
